import { useEffect } from 'react';
import { prefersReducedMotion } from './useScrollReveal';

export function useParallax(ref, speed = 0.35) {
  useEffect(() => {
    const element = ref.current;
    if (!element || prefersReducedMotion()) return undefined;

    let frame = 0;

    const update = () => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom < 0 || rect.top > viewportHeight) return;
      const offset = (rect.top + rect.height * 0.5 - viewportHeight * 0.5) * speed;
      element.style.setProperty('--parallax-y', `${offset}px`);
    };

    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        update();
        frame = 0;
      });
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [ref, speed]);
}
